import React from "react";
import { lazy } from "react";

const MessageAutomation = lazy(() => import("./MessageAutomation"));
const UseContainer = lazy(() => import("../UserContainer/UserContainer"));

function MessageAutomationPage() {
  return (
    <div>
      <UseContainer
        activePage={<MessageAutomation />}
        headerTitle={"Message Automation"}
        breadCrumb={"Message Automation"}
        breadCrumb2={"Settings"}
        linkbreadCrumb2={"/settings"}
        buttons={[]}
      />
    </div>
  );
}

export default MessageAutomationPage;
